import Timeline, { TimelineEvent } from '../Timeline/Timeline';
import { Icons } from '../Icons/Icons';
import './Menu.scss';
import { useMinimap } from '../../contexts/MinimapContext';
import { useTransition } from '../../contexts/TransitionContext';
import Lottie from 'lottie-react';
import scrollAnim from './Assets/scroll-anim.json';
import { useMusic } from '../../contexts/MusicContext';
import useWindowDimensions from '../../hooks/useWindowDimentions';

interface MenuProps {
  menuType?: string;
  progress?: number | undefined;
  events?: TimelineEvent[];
  setProgressInThreeJS?: (targetProgress: number) => void;
  onAmbassadorToggle?: () => void;
  onInfoToggle?: () => void;
  epochTitle?: string;
  ambassadorName?: string;
}

const Menu: React.FC<MenuProps> = ({
  menuType = 'museum',
  progress,
  events,
  setProgressInThreeJS,
  onAmbassadorToggle,
  onInfoToggle,
  epochTitle,
  ambassadorName,
}) => {
  const { showMinimap, toggleMinimap } = useMinimap();
  const { isPlaying, setIsPlaying, fadeAndNavigate } = useMusic();
  const { setIsPageTransitioning, setIsSceneLoaded } = useTransition();
  const windowDimensions = useWindowDimensions();

  const handleHomeBtnClick = () => {
    setIsSceneLoaded(false);
    setIsPageTransitioning(true);
    fadeAndNavigate('/?preloader=true');
  };

  return (
    <div className="menu">
      {progress !== undefined && events !== undefined && setProgressInThreeJS !== undefined && windowDimensions.width > 768 && (
        <Timeline progress={progress} events={events} setProgressInThreeJS={setProgressInThreeJS} />
      )}
      {menuType === 'museum' ? (
        <div className="menu-content">
          {windowDimensions.width > 768 && (
            <div className="btns">
              <div
                className={`menu-btn open-minimap-btn ${showMinimap ? 'active' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleMinimap();
                }}
              >
                {Icons.MenuIcon}
              </div>
            </div>
          )}
          <h1>
            {windowDimensions.width > 768 && (
              <div
                className="menu-btn info-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  onInfoToggle?.();
                }}
              >
                {Icons.InfoIcon}
              </div>
            )}
            {epochTitle}
          </h1>
          <div className="btns">
            {windowDimensions.width < 768 && (
              <div
                className="menu-btn info-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  onInfoToggle?.();
                }}
              >
                {Icons.InfoIcon}
              </div>
            )}
            
            {ambassadorName && ambassadorName !== '' && (
              <div
                className="menu-btn ambassador-btn"
                onClick={onAmbassadorToggle}
              >
                {Icons.MenuAmbassadorBtn}
              </div>
            )}
            <div className="menu-btn home-btn" onClick={handleHomeBtnClick}>
              {Icons.MenuHomeBtn}
            </div>
            {windowDimensions.width > 768 && (
              <div className={`menu-btn music-btn ${isPlaying ? 'active' : ''}`} onClick={() => setIsPlaying(!isPlaying)}>
                {Icons.MenuMusicBtn}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="menu-content">
          {windowDimensions.width > 768 && (
            <div className="btns">
              <div
                className={`menu-btn open-minimap-btn ${showMinimap ? 'active' : ''}`}
                onClick={toggleMinimap}
              >
                {Icons.MenuIcon}
              </div>
            </div>
          )}
          <div className="scroll-hint">
            {windowDimensions.width < 768 ? Icons.SwipeIcon :
              <Lottie
                animationData={scrollAnim}
                loop={true}
                autoplay={true}
                className="scroll-anim"
              />}
            {windowDimensions.width < 768 ? 'swipe up to navigate' : 'SCROLL TO NAVIGATE'}
          </div>
          {windowDimensions.width > 768 && (
            <div className="btns">
              <div className={`menu-btn music-btn ${isPlaying ? 'active' : ''}`} onClick={() => setIsPlaying(!isPlaying)}>
                {Icons.MenuMusicBtn}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Menu; 